export const ERROR_CODES_UTILITIES = {
  invalidEan: 'BOLT-UTIL-404-001'
}
export type UtilityErrorCodes = (typeof ERROR_CODES_UTILITIES)[keyof typeof ERROR_CODES_UTILITIES]
